"use strict";
// src/graphql/parseData.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseUserWalletData = parseUserWalletData;
async function parseUserWalletData(walletDataString) {
    const walletData = walletDataString;
    return walletData;
}
//# sourceMappingURL=parseData.js.map